import { useMemo } from 'react';

import { useGET } from './useGET';

const toUrl = () => '/profile';

export default function useProfile() {
  const url = toUrl();
  const data = useGET(url);

  return useMemo(() => data, [data]);
}
